<div #chatHistory class="chat-history" (mouseenter)="onHistoryHover(true)" (mouseleave)="onHistoryHover(false)">
	<stages-responsive-data-view
		#dataView
		[dataSource]="$any(dataSource)"
		[listItemTemplate]="listItemTemplate"
		[idFn]="ChatHistoryComponent.getGuid"
		[disabledFn]="ChatHistoryComponent.isDisabled"
		[translateNone]="'chatbot.chat.history.empty'"
		[showMore]="true"
		[pageSize]="pageSize"
	>
	</stages-responsive-data-view>
</div>

<ng-template #listItemTemplate let-chat>
	<a href="#" class="label" (click)="openChat(chat, $event)">
		<div class="text center">
			<span class="h4 chat-name">{{ chat.name }}</span>
			<p>{{ chat.viewName }}</p>
			<p>{{ chat.lastUpdated }}</p>
		</div>
	</a>
	<div class="action">
		<stages-menu
			menuId="muChat{{ chat.id }}"
			iconClasses="ico ico-more-vertical"
			openTo="left"
			[items]="menuItems"
			[context]="chat"
			class="action"
			[noCollapse]="true"
		>
		</stages-menu>
	</div>
</ng-template>
